<!--
   Created by qing on 2020/10/12
   Des: 
-->
<template>

  <van-popup
    v-model="visible"
    :style="{ height: '90%', width: '100%' }"
    get-container="body"
    closeable
    safe-area-inset-bottom
    position="bottom">
    <div class="ry-select-container">
      <div class="header">
        {{title}}
      </div>
      <van-search
        v-if="activeName === 'all'"
        v-model="searchInput"
        placeholder="请输入搜索关键词"
        @search="onClickSearch"
        @input="onClickSearch"/>
      <van-tabs v-model="activeName">
        <van-tab title="所有" name="all"></van-tab>
        <van-tab title="已选" name="select"></van-tab>
      </van-tabs>
      <div class="container"  v-if="activeName === 'all'">

        <div class="add-btn" v-if="isAddBtn && init">
          <create-form-apply
            :app-id="relateAppId"
            :formId="relateFormId"
            :label="`新建${relateFormName}`"
            @submitCallback="refreshData">
          </create-form-apply>
        </div>
        <div
          v-if="searchInput.length && dataList.length"
          class="search-no-data-tips"
          @click="onClickRemoteSearch">
          没有想要的搜索结果，加载更多
        </div>

        <template v-if="dataList.length">

          <van-list>
            <div class="data-source-container" >

              <div
                class="preview-card"
                v-for="item in dataList"
                :class="{'select' : selectList.includes(item)}"
                @click="rowClick(item)"
                :key="item.instanceId">
                <div class="preview-card-wrapper">
                  <div class="card-info">
                    <h3 v-if="item.title">{{item.title.showData}}</h3>
                    <div class="card-info-row">
                      <div
                        class="row-item"
                        :style="{width: `${100 / item.content.length}%`}"
                        v-for="showData in item.content"
                        :key="showData.fieldId">
                        <h5>{{showData.fieldTitle}}</h5>
                        <div class="item-content">
                          <FieldShowData :show-data="showData" :memberShowType="memberShowType"></FieldShowData>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="img-container"
                    v-if="item.image && item.image.showData">
                    <el-image :src="item.image.showData" fit="cover"></el-image>
                  </div>
                </div>
              </div>
              <template v-if="pageConf">
                <p
                  style="text-align: center; color: #5e6d82; cursor: pointer; font-size: 14px; margin: 20px 0;"
                  v-if="!loading && !scrollDisabled"
                  @click="fetchData">
                  点击加载更多
                </p>
                <p style="text-align: center; color: #5e6d82; font-size: 14px; margin: 20px 0;" v-if="loading">加载中...</p>
                <p
                  style="text-align: center; color: #5e6d82; font-size: 14px; margin: 20px 0;"
                  v-if="!loading && scrollDisabled && !(pageConf.currentPage === 1 && dataList.length === 0 && init)">
                  -------没有更多数据了-------
                </p>
              </template>
            </div>
          </van-list>
        </template>

        <div
          v-if="!dataList.length && !init"
          class="ry-select-skeleton">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>

        <div
          v-if="!dataList.length && init && !errorMsg"
          class="ry-select-empty" :style="{height: isAddBtn ? 'calc(100% - 64px)' : '100%'}">
          <img src="../../assets/images/empty.png" alt="">
          暂无数据
          <van-button
            style="margin-top: 20px"
            v-if="searchInput.length && remoteSearch"
            @click="onClickRemoteSearch">
            试试远程搜索
          </van-button>
        </div>
        <div v-if="errorMsg" class="ry-select-empty">
          <img :src="`${$BASE_PATH}/fetch/image?id=366897153697684545.png`" alt="">
          {{errorMsg}}
        </div>
      </div>

      <div
        class="container"
        style="height: calc(100% - 44px - 44px - 44px);"
        v-if="activeName === 'select'">

        <van-list v-if="selectList.length">
          <div class="data-source-container" >
            <div
              style="font-size: 14px; margin: 20px; color: #3a8ee6;"
              @click="selectList.splice(0, selectList.length)">
              清空已选
            </div>
            <div
              class="preview-card"
              v-for="item in selectList"
              :class="{'select' : selectList.includes(item)}"
              @click="rowClick(item)"
              :key="item.instanceId">
              <div class="preview-card-wrapper">
                <div class="card-info">
                  <h3 v-if="item.title">{{item.title.showData}}</h3>
                  <div class="card-info-row">
                    <div
                      class="row-item"
                      :style="{width: `${100 / item.content.length}%`}"
                      v-for="showData in item.content"
                      :key="showData.fieldId">
                      <h5>{{showData.fieldTitle}}</h5>
                      <div class="item-content">
                        <FieldShowData :show-data="showData" :memberShowType="memberShowType"></FieldShowData>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="img-container"
                  v-if="item.image && item.image.showData">
                  <el-image :src="item.image.showData" fit="cover"></el-image>
                </div>
              </div>
            </div>
          </div>
        </van-list>

        <div
          v-if="!selectList.length"
          class="ry-select-empty" :style="{height: isAddBtn ? 'calc(100% - 64px)' : '100%'}">
          <img src="../../assets/images/empty.png" alt="">
          暂无已选数据
        </div>
      </div>

      <div class="footer" v-if="init && !errorMsg">
        <van-button
          @click="visible = false">
          取 消
        </van-button>
        <van-button
          type="primary"
          @click="submitData">
          确定
        </van-button>
      </div>
    </div>
  </van-popup>
</template>

<script>
  import FieldShowData from "./FieldShowData";
  import {arrayRemove} from "../../assets/js/Untis";
  import PinyinMatch from 'pinyin-match'
  import CreateFormApply from "./CreateFormApply"
  import {FORM_ITEM__ADDRESS, FORM_ITEM__IMAGE} from "../RyForm/types";

  export default {
    props: {
      title: {
        type: String,
        default: ''
      },
      // 是否多选
      multiple: {
        type: Boolean,
        default: false
      },
      // 是否可以新建表单
      isAddBtn: {
        type: Boolean,
        default: false
      },
      // 关联表单名称(如果有新建表单，必传字段)
      relateFormName: {
        type: String,
        default: ''
      },
      // 关联表单appId(如果有新建表单，必传字段)
      relateAppId: {
        type: String,
        default: ''
      },
      // 关联表单formId(如果有新建表单，必传字段)
      relateFormId: {
        type: String,
        default: ''
      },
      // 是否在加载数据中
      loading: {
        type: Boolean,
        default: false
      },
      // 是否在本地搜索没有结果时，可以远程搜索
      remoteSearch: {
        type: Boolean,
        default: false
      },
      memberShowType: {
        type: String,
        default: ''
      },
      /*
      分页对象
       pageSize: 20,
      currentPage: 0,
      totalPage: 1,
      totalCount: 1,
       */
      pageConf: Object,
      fetchData: Function,
      refreshData: Function
    },
    data() {
      return {
        activeName: 'all',
        init: false,
        errorMsg: '',
        dataList: [],
        originDataList: [],
        visible: false,
        searchInput: '',
        selectList: [],

        remoteSearchInfo: null
      }
    },
    components: {
      CreateFormApply,
      FieldShowData
    },
    computed: {
      scrollDisabled() {
        if (!this.pageConf) {
          return  true
        }
        return this.loading || this.pageConf.totalPage === 0 || this.pageConf.currentPage >= this.pageConf.totalPage
      }
    },
    created() {
    },
    methods: {
      // {companyId, appId, formId, data, rowIdx, relateFieldId, currentDataId}
      open(opt) {
        this.remoteSearchInfo = opt || {}
        this.init = false
        this.errorMsg = ''
        this.searchInput = ''
        this.dataList.splice(0, this.dataList.length)
        this.originDataList.splice(0, this.originDataList.length)
        this.selectList.splice(0, this.selectList.length)
        this.visible = true
      },
      setDataList(dataList) {
        this.init = true
        this.dataList.splice(0, this.dataList.length, ...dataList)
        this.originDataList.splice(0, this.originDataList.length, ...dataList)
      },
      appendDataList(dataList) {
        this.dataList.push(...dataList)
        this.originDataList.push(...dataList)
      },
      addSelectList(selectList) {
        this.selectList.push(...selectList)
        if (!this.pageConf || this.pageConf.currentPage < 2) {
          if (this.selectList.length) {
            this.activeName = 'select'
          } else {
            this.activeName = 'all'
          }
        }
      },
      setError(errorMsg) {
        this.init = true
        this.errorMsg = errorMsg
      },
      onClickSearch() {
        if (!this.searchInput.length) {
          this.dataList.splice(0, this.dataList.length, ...this.originDataList)
          return
        }
        const searchResults = []
        this.originDataList.forEach(item => {
          let matchStr = item.title.showData
          item.content.forEach(item => {
            if (item.type === FORM_ITEM__ADDRESS) {
              matchStr += `${item.showData.province}${item.showData.city}${item.showData.county}${item.showData.detailAddress}`
            } else {
              matchStr += item.showData
            }
          })
          const results = PinyinMatch.match(matchStr, this.searchInput)
          if (results) {
            searchResults.push(item)
          }
        })
        this.dataList.splice(0, this.dataList.length, ...searchResults)
      },
      onClickRemoteSearch() {
        const loading = this.$toast.loading({message: '搜索中...', duration: 0})
        this.$store.dispatch('actionExternalSearchData', {
          companyId: this.remoteSearchInfo.companyId,
          appId: this.remoteSearchInfo.appId,
          formId: this.remoteSearchInfo.formId,
          fieldId: this.remoteSearchInfo.currentDataId,
          data: this.remoteSearchInfo.data,
          rowIdx: this.remoteSearchInfo.rowIdx,
          queryStr: this.searchInput,
          currentPage: 1,
          pageSize: 200
        }).then(({dataList, fieldList}) => {

          let showDataList = []
          dataList.forEach((item, idx) => {
            let showData = {
              title: {},
              image: {},
              content: [],
              item,
              instanceId: idx
            }
            showData.title = {
              showData: item.mainValue,
              fieldId: this.remoteSearchInfo.relateFieldId,
              type: 'title'
            }

            const imageArr = []
            const contentArr = []
            item.subValue.forEach(subV => {
              const field = fieldList.filter(d => d.dataId === subV.fieldId)[0]
              if (field) {
                if (field.type === FORM_ITEM__IMAGE) {
                  imageArr.push({
                    showData: subV.value && subV.value.length > 0 ? subV.value[0].imgUrl : '',
                    fieldId: field.dataId,
                    type: 'title'
                  })
                } else {
                  contentArr.push({
                    showData: subV.value,
                    type: field.type,
                    ...field
                  })
                }
              }
            })
            showData.image = imageArr.length > 0 ? imageArr[0] : {}
            showData.content = contentArr.slice(0, 4)
            showDataList.push(showData)
          })

          this.dataList.splice(0, this.dataList.length, ...showDataList)
        }).catch(err => {
          console.error(err)
        }).finally(() => {
          loading.clear()
        })
      },
      rowClick(item) {
        if (!this.multiple) {
          this.selectList.splice(0, this.selectList.length)
        }
        if (this.selectList.includes(item)) {
          arrayRemove(this.selectList, item)
        } else {
          this.selectList.push(item)
        }
      },
      submitData() {
        this.$emit('selectComplete', this.selectList)
        this.visible = false
      }
    }
  }
</script>

<style lang="less">

  .ry-select-container {
    height: 100%;

    .header {
      height: 44px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .container {
      height: calc(100% - 44px - 44px - 54px - 44px);
      overflow: auto;

      .search-no-data-tips {
        width: 100%;
        text-align: center;
        line-height: 30px;
        color: #4A66FA;
        font-size: 12px;
      }

      .add-btn {
        width: calc(100% - 20px);
        height: 40px;
        line-height: 40px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
        border-radius: 5px;
        border: 1px solid #ebeef5;
        margin: 10px;
        padding-left: 10px;

        >.create-form-apply-container {

          > .el-button {
            width: 100%;
            text-align: left;
          }
        }
      }

      .data-source-container {
        height: 100%;

        .preview-card {
          margin: 10px;
          position: relative;
          width: calc(100% - 20px);
          background-color: #fff;
          display: flex;
          border-radius: 5px;
          border: 1px solid #ebeef5;
          overflow: hidden;
          color: #303133;
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
          cursor: pointer;

          .preview-card-wrapper {
            display: flex;
            flex: 1 1;
            width: calc(100% - 5px);

            .card-info {
              flex: 1 1;
              width: calc(100% - 100px);
              border-radius: 2px;
              padding-left: 10px;

              h3 {
                height: 18px;
                font-size: 16px;
                font-weight: 700;
                color: #262626;
                line-height: 18px;
                margin: 10px 0 10px 0;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }

              .card-info-row {
                display: flex;
                flex: 1 1;
                margin-top: 10px;

                .row-item {
                  flex: 1 1;

                  h5 {
                    font-size: 11px;
                    color: #979797;
                    line-height: 16px;
                    margin: 0;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    word-wrap: break-word;
                  }

                  .item-content {
                    height: 31px;
                    display: flex;
                    align-items: center;
                    font-size: 14px;

                    > div {
                      padding-left: 0;
                      padding-right: 0;
                      margin-right: 8px;
                      overflow: hidden;
                      flex-wrap: nowrap;
                      line-height: 24px;
                      flex-grow: 1;
                      word-break: break-all;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                    }
                  }
                }
              }
            }

            .img-container {
              border-radius: 1px;
              /*border: 1px solid #f0f0f6;*/
              display: flex;
              justify-content: center;
              align-items: center;

              .el-image {
                width: 90px;
                height: 90px;
              }
            }
          }

        }

        .select {
          border: 1px solid #4A66FA;

          &:before {
            content: " ";
            z-index: 1;
            width: 31px;
            height: 31px;
            position: absolute;
            left: 0;
            top: 0;
            -webkit-transform: translate(-50%,-50%) rotate(45deg);
            transform: translate(-50%,-50%) rotate(45deg);
            background-color: #4A66FA;
          }

          &:after {
            content: " ";
            z-index: 1;
            left: 3px;
            top: 6px;
            width: 5px;
            height: 8px;
            position: absolute;
            display: table;
            border: 1px solid #fff;
            border-top: 0;
            border-left: 0;
            -webkit-transform: rotate(45deg) scale(1) translate(-50%,-50%);
            transform: rotate(45deg) scale(1) translate(-50%,-50%);
            opacity: 1;
            -webkit-transition: all .2s cubic-bezier(.12,.4,.29,1.46) .1s;
            transition: all .2s cubic-bezier(.12,.4,.29,1.46) .1s
          }
        }

        .preview-photo {
          margin: 10px 5px;
          position: relative;
          width: calc(50% - 10px);
          background-color: #fff;
          border-radius: 10px;
          border: 1px solid #ebeef5;
          overflow: hidden;
          color: #303133;
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);

          .img-container {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 200px;

            .van-image {
              width: 100%;
              height: 200px;
            }
          }

          .card-info {
            padding: 10px 10px 0 10px;

            .title {
              display: flex;
              align-items: center;

              .color {
                width: 5px;
                height: 16px;
                margin-right: 5px;
              }

              h3 {
                height: 18px;
                font-size: 16px;
                font-weight: 700;
                color: #262626;
                line-height: 18px;
                margin: 10px 0;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }


            p {
              font-size: 13px;
              margin: 0 0 10px 0;
              color: #959699;
            }

            .card-info-row {

              .row-item {
                flex: 1 1;
                margin: 10px 0;

                h5 {
                  font-size: 11px;
                  color: #979797;
                  line-height: 16px;
                  margin: 0;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  word-wrap: break-word;
                }

                .item-content {
                  height: 26px;
                  display: flex;
                  align-items: center;
                  color: #262626;
                  font-size: 14px;

                  > div {
                    padding-left: 0;
                    padding-right: 0;
                    margin-right: 8px;
                    overflow: hidden;
                    flex-wrap: nowrap;
                    line-height: 24px;
                    flex-grow: 1;
                    word-break: break-all;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }
                }
              }
            }
          }
        }
      }

      .ry-select-skeleton {
        width: 100%;
        height: 100%;

        > div {
          height: 80px;
          background-color: rgba(0, 0, 0, 0.15);
          margin: 10px;
          border-radius: 5px;
        }
      }

      .ry-select-empty {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        img {
          height: 140px;
          margin-bottom: 20px;
        }
      }
    }

    .footer {
      height: 44px;
      display: flex;
      justify-content: flex-end;
      align-items: center;

      .van-button {
        width: 50%;
      }
    }
  }
</style>